<template>
  <div :class="`reports ms-container ${isFullWidth ? 'full-width' : ''}`">
    <module-header>
      Отчеты
    </module-header>
    <div class="reports-select">
      <i-select v-model="report" size="default" @on-change="changeHandler">
        <i-option
          v-for="(item, index) in reportsList"
          :value="item.id"
          :key="item.id"
        >
          {{ index + 1 }}. {{ item.name }}
        </i-option>
      </i-select>
    </div>
    <div class="reports">
      <router-view />
    </div>
  </div>
</template>

<script>
import ModuleHeader from '@/components/parts/module-header'
import { reportsList } from '@/config/reports'

export default {
  components: {
    ModuleHeader
  },
  data () {
    return {
      reportsList
    }
  },
  computed: {
    report: {
      get () {
        return this.$store.state.reports.report
      },
      set (value) {
        this.$store.commit('SET_REPORTS_VALUE', {
          field: 'report',
          value
        })
      }
    },
    isFullWidth () {
      const fullWidthModules = [
        'reports/report_2',
        'reports/report_3',
        'reports/report_7'
      ]

      return fullWidthModules.some(m => this.$route.path.indexOf(m) > -1)
    }
  },
  methods: {
    changeHandler (value) {
      this.$router.push(`/app/reports/${value}`)
    },
    async getManagers () {
      try {
        const url = 'page/user?managers='

        const managers = await this.$store.dispatch('GET_REQUEST', { url })

        this.$store.commit('SET_MANAGERS', managers)
      } catch (error) {
        console.log(error)
      }
    },
    async getFieldManagers () {
      try {
        const url = 'page/field_manager?in_contracts='

        const fieldManagers = await this.$store.dispatch('GET_REQUEST', { url })

        this.$store.commit('SET_FIELD_MANAGERS', fieldManagers)
      } catch (error) {
        console.log(error)
      }
    }
  },
  created () {
    const { id } = this.$route.params

    this.report = id

    this.changeHandler(this.report)
    this.getManagers()
    this.getFieldManagers()
  }
}
</script>

<style lang="less">
.reports {
  &-select {
    margin-bottom: 16px;

    .ivu-select {
      width: 50%;

      &-selected-value {
        font-size: 14px !important;
        font-weight: 700;
      }
    }
  }
}
</style>
